import React, {Component} from 'react';
import logo_laravel from "../../../img/stage/laravel.png";
import logo_mongodb from "../../../img/stage/MongoDB-Logo.svg";
import campagne_widget from "../../../img/stage/2/campagne_widget.png";
import synthesis from "../../../img/stage/2/synthesis.png";
import actions_pdf from "../../../img/stage/2/actions_pdf.png";
import fork_git_projet from "../../../img/stage/2/fork_git_projet.png";
import PdfRender from "../../layout/PdfRender";

export default class Stage2 extends Component{
	render() {
		return (
			<>
				<div className="service-area section-gap white">
					<div className="container">
						<div className="row">
							<div className="col-lg-3 col-md-6">
								<div className="single-service wow fadeInUp py-4" data-wow-duration="0.8s">
									<span className="lnr lnr-apartment"> </span>
									<h4>
										<span>Entreprise</span> d'acceuil
									</h4>
									<p>
										Yakabiz <br/>
										1O Ter Rue Ledru Rollin <br/>
										66000 PERPIGNAN <br/>
										09 50 30 12 33 <br/>
										contact@yakabiz.com <br/>
										<a href="https://yakabiz.com">Site web</a>
									</p>
								</div>
							</div>
							<div className="col-lg-9 col-md-6">
								<div className="row">
									<div className="col-lg-12">
										<div className="section-title">
											<h2>Information</h2>
											<div>
												<div><b>❯ Project(s) : </b> MasterAudit, MasterKey</div>
												<div><b>❯ Technologie(s) : </b> Php, Javascript, Python, NodeJS</div>
												<div><b>❯ Framework (ou Librairie) : </b> Laravel (php), VueJS, DOMPDF</div>
												<div><b>❯ Base de données : </b> MongoDB</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="col-lg-12 mt-5">
								<h3 className="text-heading">Technologie Principal</h3>

								<h4 className="mb-20">Laravel</h4>

								<div className="row my-5">
									<div className="col-md-4">
										<img src={logo_laravel} alt="" className="img-fluid" />
									</div>
									<div className="col-md-8 mt-sm-20 text-left">

									</div>
								</div>

								<h4 className="mb-20">MongoDB</h4>

								<div className="row my-5">
									<div className="col-md-4">
										<img src={logo_mongodb} alt="" className="img-fluid" />
									</div>
									<div className="col-md-8 mt-sm-20 text-left">
										<p>
											<a href="https://www.mongodb.com/fr">Mongodb</a> est un SGBD orienté documents, et non relationnel.<br/><br/>

											Le document est l'unité de base : il peut être inséré, supprimé, recherché...
											On peut manipuler simultanément des types de documents différents sans mettre en place la moindre contrainte entre ceux-ci.
											Les documents sont contenus dans des collections réunies en bases de données.
										</p>
									</div>
								</div>
							</div>

							<div className="col-lg-12 mt-3">
								<h3 className="text-heading">MasterAudit</h3>

								<h4 className="mb-20">Presentation</h4>
								<p>
									<a href="https://yakabiz.com/solutions/">MasterAudit</a> est application web qui permettant de digitaliser des grilles d’audit en les rendant accessibles facilement en situation de mobilité.

									C'est une application web principalement ecrit en PHP utilisant le framework Laravel.
								</p>

								<h4 className="mb-20">Mon travail</h4>

								<h5>Campagne(s) (Créer un widget)</h5>
								<div className="row my-5">
									<div className="col-md-4">
										<a href={campagne_widget} className="img-gal">
											<img src={campagne_widget} alt="" className="img-fluid" />
										</a>
									</div>
									<div className="col-md-8 mt-sm-20 text-left">
										<p>
											Tout d'abord mon tout premier travail dans l'entreprise était de s'adapter à l'environnement de développement de façon collaborative,
											parce que ma première tache, c'était de travailler en commun avec l'un des développements de l'entreprise, on devait tous les deux
											travailler sur des widgets de l'interface que l'application.
										</p>
									</div>
								</div>

								<h5>Synthèse(s) et Synthèse(s) depuis les campagnes</h5>
								<div className="row my-5">
									<div className="col-md-4">
										<a href={synthesis} className="img-gal">
											<img src={synthesis} alt="" className="img-fluid" />
										</a>
									</div>
									<div className="col-md-8 mt-sm-20 text-left">
										<p>
											Pour ma seconde tâche, je devais un peu travailler tout seul puisque c'est une fonctionnalité
											qui n'avait pas été implémenter dans l'application. Je devais tout simplement faire en sorte que
											la page ne se mette à jour pas quand on sélectionne une liste d'audit afin de générer une synthèse,
											la liste sélectionnée devait être dynamique.
										</p>
									</div>
								</div>
								<div className="row my-5">
									<div className="col-md-4">
										{/*<a href={images_1} className="img-gal">
													<img src={images_1} alt="" className="img-fluid" />
												</a>*/}
									</div>
									<div className="col-md-8 mt-sm-20 text-left">
										<p>
											Bien sûr, après que cette liste soit sélectionnée,
											il fallait récupérer ses données et générer des statistiques, donc faire une synthèse des audits sélectionnés.
										</p>
									</div>
								</div>

								<h5>Génération PDF (Audit, Plan Actions)</h5>
								<div className="row my-5">
									<div className="col-md-4">
										<a href={actions_pdf} className="img-gal">
												<img src={actions_pdf} alt="" className="img-fluid" />
											</a>
									</div>
									<div className="col-md-8 mt-sm-20 text-right">
										<p>
											Ma tâche suivante était de faire la génération des PDF de quelques fonctionnalités de l'application,
											par exemple, j'ai dû m'occuper de la génération des PDF des audits ensuite celui des synthèses.
										</p>
									</div>
								</div>
								<div className="row my-5">
									<div className="col-md-8 mt-sm-20 text-right">
										<p>
											Dans tout cela, il fallait bien sûr que je prenne en compte le travail des autres développeurs,
											puisque le système de réponse des audits (Exemple: conformes, non-conformes, ...), venait d'être changé,
											donc la génération des PDF avec des réponses fixe n'était plus possible, il fallait faire en sorte que la
											génération des réponses sur le PDF soit dynamique par rapport à la synthèse.
										</p>
									</div>
									<div className="col-md-4">
										{/*<a href={images_2} className="img-gal">
												<img src={images_2} alt="" className="img-fluid" />
											</a>*/}
									</div>
								</div>

								<h4 className="mb-20" id="Versionning">Planing, Organisation, Versioning, ...</h4>

								<div className="row my-5">
									<div className="col-md-4">
										<a href={fork_git_projet} className="img-gal">
											<img src={fork_git_projet} alt="" className="img-fluid" />
										</a>
									</div>
									<div className="col-md-8 mt-sm-20 text-right">
										<p>
											En ce qui concerne la gestion du projet, j'ai pris connaissance des deux systèmes de gestion de projet que
											l'entreprise utilisée pour gérer le projet <b>MasterAudit</b>. Il y avait le versionning de base avec git (service gitlab)
											ensuite il y avait un nouveau système que je n'avais jamais vu auparavant qui s'appelle Zoho. <br/>
											Zoho offre aux entreprises une meilleure expérience de la gestion des connaissances et de collaboration sur un projet.
										</p>
									</div>
								</div>

							</div>

							<div className="col-lb-12 mt-3">
								<h3 className="text-heading">MasterKey</h3>

								<h4 className="mb-20">Presentation</h4>
								<p>
									<a href="https://yakabiz.com/solutions/">MasterKey</a> est un module qui permet de suivre, l’ensemble des clés d’un parc automobiles.
								</p>

								<h4 className="mb-20">Mon travail</h4>

								<p>
									Lors de ma présence dans l'entreprise, on m'en confier temporairement travail.
									Pendant ma prériode, MasterAudit était un projet en test et en cours de développment.
								</p>

							</div>

							{/*<div className="col-lg-12 mt-3">
								<h3 className="text-heading">Attestation de fin de stage 2</h3>

								<div className="col-lg-12 d-flex flex-column justify-content-center">
									<div className="wrapper-pdf">
										<PdfRender file="./../storage/Attestation_de_stage_periode_2_-_logo.pdf" />
									</div>
								</div>
							</div>*/}

						</div>
					</div>
				</div>
			</>
		);
	}
}